.games {
  .tutorial {
    margin-block: 64px;
  }

  h4 {
    margin: 0;
  }

  li {
    margin-bottom: 1em;
  }
}
